<template>
    <v-container fluid class="pt-0">
        <v-card class="px-5 py-3 br-15 w-100" elevation="0">
            <v-row>
                <v-col class="flex-grow-1">
                    <v-toolbar-title class="page-title"
                        >Exportação da base pré-preenchida</v-toolbar-title
                    >
                </v-col>
            </v-row>
            <v-divider class="mt-2 mb-3"></v-divider>

            <v-form ref="formFiltro" v-model="formValido">
                <v-row>
                    <v-col sm="6" md="4" lg="3" class="pb-0">
                        <v-autocomplete
                            label="Fornecedor"
                            class="input-cinza"
                            outlined
                            dense
                            :items="lista.fornecedor"
                            v-model="filtro.id_fornecedor"
                            :menu-props="menuProps"
                            :rules="regra.fornecedor"
                            clearable
                            required
                        ></v-autocomplete>
                    </v-col>
                    <v-col sm="6" md="4" lg="3" class="pb-0">
                        <v-select
                            label="Bandeira"
                            v-model="filtro.id_bandeira"
                            :items="lista.bandeira"
                            :menu-props="menuProps"
                            outlined
                            dense
                            class="input-cinza"
                            multiple
                            :rules="regra.bandeira"
                            required
                        >
                        </v-select>
                    </v-col>
                    <v-col sm="6" md="4" lg="3" class="pb-0">
                        <MesInput
                            label="Mes"
                            v-model="filtro.mes"
                            :rules="regra.mes"
                            required
                        ></MesInput>
                    </v-col>
                    <v-col sm="6" md="4" lg="3" class="pb-0">
                        <DataInput
                            label="Período Inicial"
                            v-model="filtro.dataInicio"
                            :rules="regra.periodoInicial"
                            :change="periodoInicialChange"
                            :first-day-of-week="1"
                            required
                        ></DataInput>
                    </v-col>
                    <v-col sm="6" md="4" lg="3" class="pb-0">
                        <DataInput
                            label="Período Final"
                            v-model="filtro.dataFinal"
                            :rules="regra.periodoFinal"
                            :change="periodoFinalChange"
                            :first-day-of-week="1"
                            required
                        ></DataInput>
                    </v-col>
                    <v-col sm="6" md="4" lg="3" class="pb-0">
                        <v-autocomplete
                            label="Ativação"
                            class="input-cinza"
                            outlined
                            dense
                            :items="lista.ativacoes"
                            v-model="filtro.id_ativacao"
                            :menu-props="menuProps"
                            :rules="regra.ativacao"
                            required
                            multiple
                        ></v-autocomplete>
                    </v-col>
                    <v-col sm="6" md="4" lg="3" class="pb-0">
                        <v-autocomplete
                            label="Ativação personalizada"
                            class="input-cinza"
                            outlined
                            dense
                            :items="lista.ativacoes"
                            v-model="filtro.id_ativacao_personalizada"
                            :menu-props="menuProps"
                            required
                            multiple
                        ></v-autocomplete>
                    </v-col>
                    <v-col sm="6" md="4" lg="3" class="pb-0">
                        <v-autocomplete
                            label="Categoria"
                            class="input-cinza"
                            outlined
                            dense
                            :items="lista.categorias"
                            v-model="filtro.id_categoria"
                            :menu-props="menuProps"
                            required
                            multiple
                        ></v-autocomplete>
                    </v-col>

                    <v-col sm="6" md="4" lg="3" class="pb-0">
                        <v-autocomplete
                            label="Pacote"
                            class="input-cinza"
                            outlined
                            dense
                            :items="lista.pacotes"
                            v-model="filtro.id_pacote"
                            :menu-props="menuProps"
                            required
                            multiple
                        ></v-autocomplete>
                    </v-col>
                    <v-col sm="6" md="4" lg="3" class="pb-0">
                        <v-autocomplete
                            label="Plano"
                            class="input-cinza"
                            outlined
                            dense
                            :items="lista.planos"
                            v-model="filtro.plano"
                            :menu-props="menuProps"
                            required
                            multiple
                        ></v-autocomplete>
                    </v-col>
                    <v-col sm="6" md="4" lg="3" class="pb-0">
                        <v-autocomplete
                            label="Macro Fornecedor"
                            class="input-cinza"
                            outlined
                            dense
                            :items="lista.macrofornecedor"
                            v-model="filtro.id_macrofornecedor"
                            :menu-props="menuProps"
                            required
                            multiple
                        ></v-autocomplete>
                    </v-col>
                    <!-- <v-col md="3" class="pb-0"> </v-col> -->
                    <v-col sm="6" md="4" lg="3" class="pb-0 d-flex justify-end">
                        <v-btn
                            class="new-button"
                            color="primary"
                            @click="filtrar()"
                        >
                            <v-icon left>mdi-filter</v-icon> Filtrar
                        </v-btn>
                    </v-col>
                </v-row>
            </v-form>
        </v-card>
        <!-- Se dados for null, mostrar mensagem que o usuariio precisa filtrar -->
        <v-card
            v-if="dados == null"
            class="px-5 py-5 br-15 w-100 mt-5"
            elevation="0"
        >
            <v-alert
                type="info"
                class="px-5 py-5 br-15 w-100 mt-5"
                elevation="0"
                text
            >
                <span>Selecione os filtros para buscar as oportunidades.</span>
            </v-alert>
        </v-card>
        <!-- Se houver erro, mostrar alerta -->
        <v-card
            v-else-if="erro"
            class="px-5 py-5 br-15 w-100 mt-5"
            elevation="0"
        >
            <v-alert
                type="error"
                class="px-5 py-5 br-15 w-100"
                elevation="0"
                text
            >
                <span>{{ erro }}</span>
            </v-alert>
        </v-card>
        <v-card v-else class="px-5 py-5 br-15 w-100 mt-5" elevation="0">
          <!-- Botão para exportar -->
          <v-btn color="primary" class="new-button mb-3" @click="exportar()">
            <v-icon left>mdi-microsoft-excel</v-icon>
            Exportar
          </v-btn>
            <v-data-table
                class="elevation-0 tabela"
                :headers="headers"
                :items="dados"
                :items-per-page="10"
                :footer-props="tableConfig"
                :header-props="{ sortIcon: 'mdi-chevron-down' }"
                item-key="id_oportunidade"
                multi-sort
            >
                <template v-slot:[`item.inicio`]="{ item }">
                    {{ $moment(item.inicio).format('DD/MM/YYYY') }}
                </template>
                <template v-slot:[`item.fim`]="{ item }">
                    {{ $moment(item.fim).format('DD/MM/YYYY') }}
                </template>
                <template v-slot:[`item.id_bandeira`]="{ item }">
                    {{ item.id_bandeira == 1 ? 'Raia' : 'Drogasil' }}
                </template>
            </v-data-table>
        </v-card>
        <v-overlay :value="carregando" :z-index="300">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
</template>

<script>
import useFiltros from '@/hooks/useFiltros'
export default {
    name: 'exportacao modelo',
    setup() {
        const { isLoading, isError, isFetching, data, error, refetch } =
            useFiltros('/planejamentoEcommerce/listaCampos')
        return {
            isLoading,
            isError,
            isFetching,
            lista: data,
            error,
            refetch,
        }
    },
    data() {
        return {
            formValido: false,

            menuProps: {
                bottom: true,
                offsetY: true,
                contentClass: 'select-outline',
                transition: 'slide-y-transition',
            },

            filtro: {
                mes: this.$moment().format('YYYY-MM'),
                id_bandeira: [],
                dataInicio: null,
                dataFinal: null,
                id_fornecedor: null,
            },

            carregando: false,

            tableConfig: {
                itemsPerPageOptions: [5, 10, 20, 50, 100, -1],
                itemsPerPageText: 'Linhas por páginas',
                ofText: 'de',
                pageText: '{0}-{1} de {2}',
            },

            dados: null,
            erro: null,
            regra: {
                fornecedor: [(v) => !!v || 'Fornecedor é obrigatório'],
                bandeira: [
                    (v) =>
                        (v && v.length > 0) ||
                        'Selecione ao menos uma bandeira',
                ],
                mes: [(v) => !!v || 'Mês é obrigatório'],
                // pacote: [(v) => !!v || 'Pacote é obrigatório'],
            },
            listaPlanos: ['Anual', 'Avulso'],
            headers: [
                {
                    text: 'Bandeira',
                    value: 'id_bandeira',
                    class: 'th-separador ',
                    align: 'center',
                },
                {
                    text: 'Ativação',
                    value: 'ativacao',
                    class: 'th-separador ',
                    align: 'center',
                },
                {
                    text: 'Categoria',
                    value: 'categoria',
                    class: 'th-separador ',
                    align: 'center',
                },
                // inicio, fim, plano, mes ,semana
                {
                    text: 'Inicio',
                    value: 'inicio',
                    class: 'th-separador ',
                    align: 'center',
                },

                {
                    text: 'Fim',
                    value: 'fim',
                    class: 'th-separador ',
                    align: 'center',
                },

                {
                    text: 'Plano',
                    value: 'plano',
                    class: 'th-separador ',
                    align: 'center',
                },

                {
                    text: 'Mes',
                    value: 'mes',
                    class: 'th-separador ',
                    align: 'center',
                },

                {
                    text: 'Semana',
                    value: 'semana',
                    class: 'th-separador ',
                    align: 'center',
                },
                // disponibilidade Inventario, Disponibilidade Pacote
                {
                    text: 'Disponibilidade Inventario',
                    value: 'usoInventario',
                    class: 'th-separador ',
                    align: 'center',
                },
                {
                    text: 'Disponibilidade Pacote',
                    value: 'usoPacote',
                    class: 'th-separador ',
                    align: 'center',
                },
                // usoPacote
            ],
        }
    },

    created() {
        // this.filtrar()
    },
    computed: {
        extension() {
            return this.file
                ? this.file.name.split('.').pop().toLowerCase()
                : ''
        },
    },
    methods: {
        async exportar() {
                 // Valida o formulário antes de filtrar
                 if (!this.$refs.formFiltro.validate()) {
                this.$dialog.notify.warning(
                    'Por favor, preencha todos os campos obrigatórios!'
                )
                return
            }

            this.carregando = true
            this.erro = null
            const data = this.filtro
            const response = await this.$http().post(
              'planejamentoEcommerce/planejamentoFornecedor/exportar',
              data
            )

            if (response.status == 200) {
                this.$dialog.notify.success('Exportação realizada com sucesso!')
                window.location = this.$http('baseURL') + response.data.url
            } else {
                this.$dialog.notify.error(
                    response.data.mensagem || 'Erro ao exportar Exportação!'
                )
            }
            this.carregando = false
        },

        async filtrar() {
            // Valida o formulário antes de filtrar
            if (!this.$refs.formFiltro.validate()) {
                this.$dialog.notify.warning(
                    'Por favor, preencha todos os campos obrigatórios!'
                )
                return
            }

            this.carregando = true
            this.erro = null
            const data = this.filtro
            const response = await this.$http().post(
                'planejamentoEcommerce/planejamentoFornecedor/disponibilidade',
                data
            )

            // Verifica se há erro na resposta
            if (response.data && response.data.error === true) {
                this.erro = response.data.message
                this.dados = []
            } else if (response.data && response.data.length > 0) {
                this.dados = response.data
            } else {
                this.dados = []
            }
            this.carregando = false
        },
    },
}
</script>
